import { render } from "./NotePriorityList.vue?vue&type=template&id=43de7e37"
import script from "./NotePriorityList.vue?vue&type=script&lang=js"
export * from "./NotePriorityList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__